import apexchart from "../../../../node_modules/vue-apexcharts";
import alertModel from '../../../components/Dialogs/alertModal';
import {globalFunctions} from '@/mixins/globalFunctions'

export default {
  name: "TradingAnalysis",
  components: { apexchart , alertModel },
  mixins:[globalFunctions],
  data() {
    return {
      pScoreSeries: [this.getFixedVal(this.TradingAnalysisTotalScore.total_marks.Pct_score)],
      pEpsStrength: [this.getFixedVal(this.TradingAnalysisScorecard['EPS Strength'].Pct)],
      pAnnualSalesGrowth: [this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Annual)'].Pct)],
      pAnnualRoe: [this.getFixedVal(this.TradingAnalysisScorecard['ROE (Annual)'].Pct)],
      pNetMarginAnnual: [this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].Pct)],
      pAnnualDebtEquity: [this.getFixedVal(this.TradingAnalysisScorecard['Debt/Equity (Annual)'].Pct)],
      pQuarterlySalesGrowth: [this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Quarterly)'].Pct)],
      pQuarterlyEPSGrowth: [this.getFixedVal(this.TradingAnalysisScorecard['EPS Growth (Quarterly)'].Pct)],
      pLiquidityAndMarketCap: [this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].Pct)], //data
      pSectorBias: [this.getFixedVal(this.TradingAnalysisScorecard['Sector Bias'].Pct)],
      pDividendBias: [this.getFixedVal(this.TradingAnalysisScorecard['Dividend Bias'].Pct)],
      pWinLossRate: [this.getFixedVal(this.TradingAnalysisScorecard['Win Rate (%)'].Pct)],
      pRiskReward: [this.getFixedVal(this.TradingAnalysisScorecard['Risk Reward (X)'].Pct)],
      pHoldingdays: [this.getFixedVal(this.TradingAnalysisScorecard['Holding days (X)'].Pct)],
      pLossAversion: [this.getFixedVal(this.TradingAnalysisScorecard['Loss Aversion'].Pct)],
      pWinnersTurnLosers: [this.getFixedVal(this.TradingAnalysisScorecard['Winners turn Losers'].Pct)],
      pBuyerDemand: [this.getFixedVal(this.TradingAnalysisScorecard['Buyer Demand'].Pct)],
      pPriceStrength: [this.getFixedVal(this.TradingAnalysisScorecard['Price Strength'].Pct)],
      pIdealBuyRange: [this.getFixedVal(this.TradingAnalysisScorecard['Ideal Buy Range'].Pct)],
      pMovingAverages: [this.getFixedVal(this.TradingAnalysisScorecard['Moving Averages'].Pct)],
      pDrawdown: [this.getFixedVal(this.TradingAnalysisScorecard.Drawdown.Pct)],

      pTotalReturn: [this.getFixedVal(this.TradingAnalysisScorecard['Total Return'].Pct)],
      pCAGRReturn: [this.getFixedVal(this.TradingAnalysisScorecard['CAGR Return'].Pct)],
      pYTDReturn: [this.getFixedVal(this.TradingAnalysisScorecard['YTD Return'].Pct)],
      pSharpeRatio: [this.getFixedVal(this.TradingAnalysisScorecard['Sharpe Ratio'].Pct)],
      pSortinoRatio: [this.getFixedVal(this.TradingAnalysisScorecard['Sortino Ratio'].Pct)],
      pCalmarRatio: [this.getFixedVal(this.TradingAnalysisScorecard['Calmar Ratio'].Pct)],
      pOmega: [this.getFixedVal(this.TradingAnalysisScorecard.Omega.Pct)],
      pPortfolioDrawdown: [this.getFixedVal(this.TradingAnalysisScorecard['Portfolio Drawdown'].Pct)],
      portfolioHeader: this.TradingAnalysisTotalScore.total_marks.Pct_score >= 85 ? 'GREAT' : this.TradingAnalysisTotalScore.total_marks.Pct_score >= 65 ? 'GOOD' : this.TradingAnalysisTotalScore.total_marks.Pct_score >= 45 ? 'FAIR' : this.TradingAnalysisTotalScore.total_marks.Pct_score >= 20 ? 'POOR' : 'VERY POOR',

      //Values
      pEpsStrengthValue: this.getFixedVal(this.TradingAnalysisScorecard['EPS Strength'].value),
      pAnnualSalesGrowthValue: this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Annual)'].value),
      pAnnualRoeValue: this.getFixedVal(this.TradingAnalysisScorecard['ROE (Annual)'].value),
      pNetMarginAnnualValue: this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].value),
      pAnnualDebtEquityValue: this.getFixedVal(this.TradingAnalysisScorecard['Debt/Equity (Annual)'].value),
      pQuarterlySalesGrowthValue: this.getFixedVal(this.TradingAnalysisScorecard['Sales Growth (Quarterly)'].value),
      pQuarterlyEPSGrowthValue: this.getFixedVal(this.TradingAnalysisScorecard['EPS Growth (Quarterly)'].value),
      pLiquidityAndMarketCapValue: this.getFixedVal(this.TradingAnalysisScorecard['Net Margin (Annual)'].value), //data
      pSectorBiasValue: this.getFixedVal(this.TradingAnalysisScorecard['Sector Bias'].value),
      pDividendBiasValue: this.getFixedVal(this.TradingAnalysisScorecard['Dividend Bias'].value),
      pWinLossRateValue: this.getFixedVal(this.TradingAnalysisScorecard['Win Rate (%)'].value),
      pRiskRewardValue: this.getFixedVal(this.TradingAnalysisScorecard['Risk Reward (X)'].value),
      pHoldingdaysValue: this.getFixedVal(this.TradingAnalysisScorecard['Holding days (X)'].value),
      pLossAversionValue: this.getFixedVal(this.TradingAnalysisScorecard['Loss Aversion'].value),
      pWinnersTurnLosersValue: this.getFixedVal(this.TradingAnalysisScorecard['Winners turn Losers'].value),
      pBuyerDemandValue: this.getFixedVal(this.TradingAnalysisScorecard['Buyer Demand'].value),
      pPriceStrengthValue: this.getFixedVal(this.TradingAnalysisScorecard['Price Strength'].value),
      pIdealBuyRangeValue: this.getFixedVal(this.TradingAnalysisScorecard['Ideal Buy Range'].value),
      pMovingAveragesValue: this.getFixedVal(this.TradingAnalysisScorecard['Moving Averages'].value),
      pDrawdownValue: this.getFixedVal(this.TradingAnalysisScorecard.Drawdown.value),

      pTotalReturnValue: this.getFixedVal(this.TradingAnalysisScorecard['Total Return'].value),
      pCAGRReturnValue: this.getFixedVal(this.TradingAnalysisScorecard['CAGR Return'].value),
      pYTDReturnValue: this.getFixedVal(this.TradingAnalysisScorecard['YTD Return'].value),
      pSharpeRatioValue: this.getFixedVal(this.TradingAnalysisScorecard['Sharpe Ratio'].value),
      pSortinoRatioValue: this.getFixedVal(this.TradingAnalysisScorecard['Sortino Ratio'].value),
      pCalmarRatioValue: this.getFixedVal(this.TradingAnalysisScorecard['Calmar Ratio'].value),
      pOmegaValue: this.getFixedVal(this.TradingAnalysisScorecard.Omega.value),
      pPortfolioDrawdownValue: this.getFixedVal(this.TradingAnalysisScorecard['Portfolio Drawdown'].value),

      apexheight: globalFunctions.getScreenWidth(),
      portfolioScoreChartOptions: {
        tooltip: {
          enabled: false,
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}`;
            },
          },
        },
        chart: {
          type: "radialBar",
          offsetY: -20,
          offsetX: 250,
          sparkline: {
            enabled: true,
          },
          height: "400px",
        },
        colors: ["#ecf018"],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#000000",
              strokeWidth: "100%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: screen.width > 500 ? '24px': '10px',
                fontFamily: undefined,
                fontWeight: 600,
                color: "#fff",
                offsetY: -8,
                formatter: function (val,opts) {
                  return val;
                },
              },
            },
            hollow: {
              margin: 50,
              size: "38%",
              background: "#000000",
              image: undefined,
              imageWidth: 150,
              imageHeight: 150,
              imageOffsetX: 0,
              imageOffsetY: 0,
              imageClipped: true,
              position: "front",
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
          },
        },

        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#f06616'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
          stroke: {
            lineCap: "butt",
          },

        labels: ["Portfolio Score"],
      },
       tradeChartOptions: {
        tooltip: {
          enabled: false,
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
          fillSeriesColor:true,
        },
        chart: {
          type: "radialBar",
          offsetY: -20,
          offsetX: 250,
          sparkline: {
            enabled: true,
          },
          height: "400px",
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#1f58a0",
              strokeWidth: "100%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              show: false,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: "24px",
                fontFamily: undefined,
                fontWeight: 600,
                color: "#104c99",
                offsetY: -15,
                formatter: function (val,opts) {
                  return val;
                },
              },
            },
            hollow: {
              margin: 10,
              size: "36%",
              background: "#fff",
              image: undefined,
              imageWidth: 150,
              imageHeight: 150,
              imageOffsetX: 0,
              imageOffsetY: 0,
              imageClipped: true,
              position: "front",
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5,
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          opacity: 1.5,
          colors: ["#acb8c9"],
          type: "gradient",
          gradient: {
            gradientToColors: ["#acb8c9"],
            shadeIntensity: 1,
            opacityFrom: 1,
            opacityTo: 2,
            stops: [0, 50, 100],
            inverseColors: false,
          },
          stroke: {
            lineCap: "round",
          },
        },
        labels: ["Percentage"],
      },
    };
  },
  props: [
    "TradingAnalysisScorecard",
    "TradingAnalysisComments",
    "TradingAnalysisTotalScore",
    "overallComment"
  ],
  methods: {
    callReport(){

      $("#slider2").roundSlider({
        radius: 100,
        width: 40,
        handleSize: "38,2",
        handleShape: "square",
        sliderType: "min-range",
        value: 40,
        circleShape: "half-top"
      });

      var sliderObj = $("#slider2").data("roundSlider");
      sliderObj.setValue(60);
    },
    calculateScorePct(value) {
      return `width: ${value}%`;
    },
    getFixedVal(value) {
      if (
        value === null ||
        value === "" || parseFloat(value) >= 9999 || parseFloat(value) <= -9999
      ) {
        return "NA";
      }
      else if(isNaN(value)){
        return value
      }
      else {
        return parseFloat(value).toFixed(1);
      }
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    scrollToElement(section){
      const el = this.$el.getElementsByClassName(section)[0];

    if (el) {
      // Use el.scrollIntoView() to instantly scroll to the element
      el.scrollIntoView({behavior: 'smooth'});
    }
    }
  },
};




// WEBPACK FOOTER //
// ./src/assets/js/Report/TradingAnalysis.js